var map = {
	"./account-info-bg.png": "add4",
	"./alert-info-icon.png": "6671",
	"./arrow-circle-right-icon.png": "0afa",
	"./arrow-left.svg": "f3a0",
	"./avatar-placeholder.png": "43ad",
	"./banner-campaign.svg": "d8fe",
	"./bottom-bg.png": "8a2c",
	"./button-bg.svg": "703f",
	"./calendar-icon.png": "a915",
	"./calendar.png": "401b",
	"./campaign-image-placeholder.svg": "0948",
	"./campaign-point.png": "d179",
	"./campaign-registered-icon.svg": "752b",
	"./circle-info-gray-icon.svg": "b9d1",
	"./circle-info-icon.png": "a510",
	"./close-banner-icon.svg": "09e2",
	"./close.png": "04b3",
	"./clubcard-gold-bg.svg": "e3c3",
	"./clubcard-gold.svg": "fc59",
	"./clubcard-loyalty-bg-barcord.svg": "3771",
	"./clubcard-loyalty-bg.svg": "a90b",
	"./clubcard-loyalty-with-qr-code.png": "d628",
	"./clubcard-loyalty.png": "a122",
	"./clubcard-online.png": "e1f2",
	"./coin-adjustment-in.png": "fb3e",
	"./coin-adjustment-out.png": "49b3",
	"./coin-exchange-banner.png": "c640",
	"./coin-transfer-in.png": "a38e",
	"./coin-transfer-out.png": "1409",
	"./copy.png": "e61d",
	"./coupon-image-placeholder.png": "553f",
	"./coupon-outline-icon.png": "7776",
	"./default-avatar.png": "889b",
	"./earn.png": "9537",
	"./error.png": "b948",
	"./expiry.png": "0a30",
	"./gold-onboard-bg.svg": "fe52",
	"./gold-onboard-image.svg": "9a65",
	"./gold-star-icon.svg": "cac4",
	"./gold-tier-badge-icon.svg": "5a7f",
	"./header-coin-history.png": "565f",
	"./header-coin-history.svg": "57bd",
	"./history.png": "1c5f",
	"./history.svg": "3b6f",
	"./idcard-icon.png": "f02c",
	"./idcard-icon.svg": "49d0",
	"./info-notification-icon.png": "8df3",
	"./laser-id-card-icon.png": "680d",
	"./loading-dot-icon.gif": "aaac",
	"./loading-spinner.png": "65d1",
	"./lotus-logo.png": "0a55",
	"./lotuss-coin.png": "a1fb",
	"./lotuss-logo.png": "5e9a",
	"./modal-bottom-barcode-bg.png": "ad2d",
	"./my-coupon-icon.png": "a6b6",
	"./my-qr-code-icon.svg": "6daf",
	"./no-image-placeholder-carausol.png": "ebb6",
	"./no-image-placeholder-single.png": "4742",
	"./no-transaction.png": "b82e",
	"./offer-icon.png": "f824",
	"./otp-icon.png": "3887",
	"./otp-icon.svg": "0e77",
	"./partner-coupon-banner.png": "29f1",
	"./qr-code-icon.png": "0599",
	"./redeem.png": "a8db",
	"./redeem.svg": "c56f",
	"./reward-coin-icon.svg": "1561",
	"./reward-coupon-icon.svg": "22ea",
	"./right.svg": "50d7",
	"./special-for-you-icon.png": "0714",
	"./try-again-icon.png": "a16f",
	"./unlink-confirmation-icon.png": "15ee",
	"./unlink-icon.png": "ffec",
	"./unlink-line-icon.png": "b47a",
	"./warning-confirmation-icon.png": "afcb",
	"./warning-no-internet-icon.png": "aa6d",
	"./warning-no-internet-icon.svg": "4586",
	"./warning-notification-icon.png": "c86a",
	"./warning-request-timeout-icon.png": "1c13",
	"./warning-request-timeout-icon.svg": "56cb",
	"./warning-token-expired-icon.png": "10ea",
	"./warning-token-expired-icon.svg": "f73c",
	"./x-button.png": "e03e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";